export default "__VITE_ASSET__DiMYetpu__"